import { SERVICES_CODES, SERVICES_GROUPS } from 'app/config/services';
import helpers from 'app/utils/helpers';
import { linePayload } from '../payloadsStruture';
import { getCompanyDataToInitialValue } from './company';

export const withSchedulesTable = [
    SERVICES_CODES.SLIC_MODIFICACAO_HORARIOS,
    SERVICES_CODES.SLIC_AMPLIACAO_HORARIOS,
    SERVICES_CODES.SLIC_SUPRESSAO_HORARIOS,
    SERVICES_CODES.STRIP_ENCURTAMENTO_LINHA,
    SERVICES_CODES.STRIP_PROLONGAMENTO_LINHA,
    SERVICES_CODES.STRIP_REFORCO_HORARIOS,
    SERVICES_CODES.STRIP_CONEXAO_LINHAS,
    SERVICES_CODES.STRIP_ALTERACAO_DEFINITIVA_ITINERARIO,
    SERVICES_CODES.STRIP_ALTERACAO_PROVISORIA_ITINERARIO,
    SERVICES_CODES.STRIP_INCLUSAO_TIPO_EQUIPAMENTO,
    SERVICES_CODES.STRIP_SUBSTITUICAO_TIPO_EQUIPAMENTO,
    SERVICES_CODES.STRIP_MODIFICACAO_HORARIOS,
    SERVICES_CODES.STRIP_AMPLIACAO_HORARIOS,
    SERVICES_CODES.STRIP_SUPRESSAO_HORARIOS,
];

const withStripContext = [...SERVICES_GROUPS.LINES_STRIP];

export const setupLinePayload = ({
    values,
    cdServico,
    linha,
    horarios,
    linhasSolicitacao,
    inspectedVehicles = [],
    equipamento,
    equipamentoSubst,
}) => {
    const linhaCopy = { ...linha };
    delete linhaCopy.quadroHorarios;
    delete linhaCopy.polo;
    const isStripLinesTransfer = SERVICES_CODES.STRIP_TRANSFERENCIA_LINHA === cdServico;
    const valuesCopy = { ...values, cdLinha: linha.cdLinha, linha: isStripLinesTransfer ? null : linhaCopy };
    if (valuesCopy.deCpfCnpjSucessor)
        valuesCopy.deCpfCnpjSucessor = helpers.somenteAlfanumericos(valuesCopy.deCpfCnpjSucessor);
    if (valuesCopy.deCpf) {
        valuesCopy.deCpf = helpers.somenteAlfanumericos(valuesCopy.deCpf);
    }
    if (withSchedulesTable.includes(cdServico)) {
        const tempScheduleBoard = { cdLinha: linha.cdLinha };
        tempScheduleBoard.horarios = horarios.map((entry) => {
            const temp = { ...entry };
            if (temp.cdLinhaQuadroHorario) delete temp.cdLinhaQuadroHorario;
            if (temp.cdLinhaQuadroHorarioHora) delete temp.cdLinhaQuadroHorarioHora;
            return temp;
        });
        valuesCopy.cdLinhaQuadroHorario = tempScheduleBoard.cdLinhaQuadroHorario;
        valuesCopy.quadroHorarios = tempScheduleBoard;
    }

    if (valuesCopy.cdVeiculoAntigo) {
        const found = inspectedVehicles.find((v) => String(v.cdVeiculo) === String(valuesCopy.cdVeiculoAntigo));
        if (found) valuesCopy.veiculoAntigo = found;
    }

    if (valuesCopy.cdVeiculo) {
        const found = inspectedVehicles.find((v) => String(v.cdVeiculo) === String(valuesCopy.cdVeiculo));
        if (found) valuesCopy.veiculo = found;
    }

    if (withStripContext.includes(cdServico)) {
        if (linhasSolicitacao && linhasSolicitacao.length > 0) {
            valuesCopy.linhasSolicitacao = linhasSolicitacao;
        }

        if (equipamento && Object.keys(equipamento).length === 2) {
            valuesCopy.tipoVeiculo = equipamento.tipo;
            valuesCopy.categoriaVeiculo = equipamento.categoria;
        }

        if (equipamentoSubst && Object.keys(equipamento).length === 2) {
            valuesCopy.tipoVeiculoSubst = equipamentoSubst.tipo;
            valuesCopy.categoriaVeiculoSubst = equipamentoSubst.categoria;
        }
    }

    return valuesCopy;
};

export const setupLinesInicialValues = (internalNewRequest) => {
    return { ...linePayload, ...getCompanyDataToInitialValue(internalNewRequest) };
};
